import React from 'react';

import { Table } from '@qality/common-components/src/atoms/Table';

import { useTestCaseRepositoryIssuesContext } from '../../../TestCaseRepositoryIssuesProvider';
import { NUMBER_OF_COLUMNS } from '../../TestCaseRepositoryTable';
import { EmptyFolder } from './EmptyFolder';
import { EmptyRepository } from './EmptyRepository';

export default function TableBodyRowEmpty(): JSX.Element {
  const { empty } = useTestCaseRepositoryIssuesContext();

  return (
    <Table.Tr>
      <Table.Td colSpan={NUMBER_OF_COLUMNS}>
        {empty === 'folder-without-filter' ? (
          <EmptyFolder />
        ) : (
          <EmptyRepository />
        )}
      </Table.Td>
    </Table.Tr>
  );
}
